import React, { Component } from "react";
import {
    Row,
    Col,
    Table
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import moment from "moment";
import { getFullName } from "../../helpers/functions/employee";

class SSSReport extends Component {

    render() {

        const { reportData, startDate, endDate } = this.props;

        return (
            <Row>
              <div style={{
                marginTop: '60px'
              }}></div>
              <Col md={12}>
                <Card
                  title="SSS Report"
                  category={moment(startDate).format('MM/DD/YYYY') + " - " + moment(endDate).format('MM/DD/YYYY') }
                  ctTableFullWidth
                  ctTableResponsive
                  content={
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th>Names</th>
                          <th>SS Number</th>
                          <th>Salary</th>
                          <th>Period</th>
                          <th>ER</th>
                          <th>EE</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportData && reportData.length > 0 
                          ? reportData.map((employee) => {
                            return (
                              <tr key={employee.employee._id}>
                                <td>{getFullName(employee.employee)}</td>
                                <td>{employee.employee.sssNumber}</td>
                                <td>{employee.salary}</td>
                                <td>{employee.periodDuration}</td>
                                <td>{Number(employee.er).toFixed(2)}</td>
                                <td>{Number(employee.ee).toFixed(2)}</td>
                                <td>{(Number(employee.er) + Number(employee.ee)).toFixed(2)}</td>
                              </tr>
                            )
                          })
                          : (
                            <tr>
                              <td colSpan='7'>No results found.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  }
                />
              </Col>
            </Row>
        )
    }
}

export default SSSReport;
